interface FooterProps {
  onSubscribe: () => void;
}

const footerColumns = [
  {
    title: '浏览',
    links: [
      { label: '今日热度榜', href: '#ranking' },
      { label: '专题合集', href: '#collections' },
      { label: '最新爆料', href: '#latest' },
      { label: '独家深挖', href: '#dig' },
    ],
  },
  {
    title: '题材',
    links: [
      { label: '剧组风波', href: '#collections' },
      { label: '资本暗线', href: '#collections' },
      { label: '合约迷局', href: '#collections' },
      { label: '旧照回流', href: '#collections' },
    ],
  },
  {
    title: '关于',
    links: [
      { label: '线索收集说明', href: '#top' },
      { label: '内容修订记录', href: '#dig' },
      { label: '隐私与保密', href: '#subscribe' },
      { label: '联系编辑部', href: '#subscribe' },
    ],
  },
];

export default function Footer({ onSubscribe }: FooterProps) {
  return (
    <footer className="w-full bg-primary-950 pt-14 text-background-100">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 pb-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-file-shield-2-line text-lg" />
              </span>
              <span className="font-heading text-[17px] font-bold text-background-50">
                黑料网曝
              </span>
            </div>
            <p className="mt-4 max-w-sm font-body text-[13px] leading-relaxed text-primary-100/80">
              黑料网曝独家爆料专区，深挖内幕与猛料。私密信息来源、事件背后不为人知的细节，都在这里集中呈现，
              满足你的好奇与求证。
            </p>
            <button
              type="button"
              onClick={onSubscribe}
              className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2.5 font-label text-[13px] font-medium text-primary-800 transition-colors hover:bg-background-100"
            >
              订阅爆料简报
              <i className="ri-arrow-right-line text-[15px]" />
            </button>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-label text-[12px] tracking-[0.28em] text-primary-200/70">
                {column.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="font-body text-[13px] text-primary-100/85 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 border-t border-primary-800/60 py-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-body text-[12px] text-primary-200/70">
            © {new Date().getFullYear()} 黑料网曝 · 独家深挖 · 内容仅供浏览参考
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="font-body text-[12px] text-primary-200/70">
              <i className="ri-shield-check-line mr-1.5" />
              线索来源严格保密
            </span>
            <a
              href="#top"
              className="font-body text-[12px] text-primary-200/70 transition-colors hover:text-background-50"
            >
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}